// Lógica pura del pase a fiscal (la pantalla vive en PaseFiscal.jsx).

export const PROGRAMA_PASE_FISCAL = 'pasefiscal';

export const SEMAFORO = {
  listo: { etiqueta: 'Listo', orden: 0 },
  sin_comprobante: { etiqueta: 'Sin comprobante', orden: 1 },
  bloqueado: { etiqueta: 'Bloqueado', orden: 2 },
};

export const MESES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export const claveAsiento = (a) => `${a.documento}|${a.numero}`;

const esPendiente = (a) => (a.estadofiscal || 'P') === 'P';

/** Un asiento se puede pasar si está pendiente y no está bloqueado. */
export const sePuedePasar = (a) => esPendiente(a) && a.semaforo !== 'bloqueado';

/** Selección inicial de la bandeja: solo lo que está listo. Lo que no tiene
 *  comprobante lo marca el usuario a conciencia. */
export function seleccionInicial(asientos) {
  return new Set(
    (asientos || []).filter((a) => esPendiente(a) && a.semaforo === 'listo').map(claveAsiento)
  );
}

/** El mes del asiento ya está cerrado en fiscal: entra con la fecha del pase. */
export function mesFiscalCerrado(fechaIso, ano, mes) {
  if (!ano || !mes || !fechaIso) return false;
  const [y, m] = String(fechaIso).split('-').map(Number);
  if (!y || !m) return false;
  return y < Number(ano) || (y === Number(ano) && m < Number(mes));
}

/** Resumen de lo seleccionado para la vista previa del pase. */
export function resumenSeleccion(asientos, seleccion, ano, mes) {
  const elegidos = (asientos || []).filter((a) => seleccion.has(claveAsiento(a)) && sePuedePasar(a));
  const porDocumento = {};
  let debito = 0;
  let credito = 0;
  elegidos.forEach((a) => {
    debito += Number(a.debito) || 0;
    credito += Number(a.credito) || 0;
    const d = porDocumento[a.documento] || { documento: a.documento, asientos: 0, debito: 0 };
    d.asientos += 1;
    d.debito += Number(a.debito) || 0;
    porDocumento[a.documento] = d;
  });
  return {
    asientos: elegidos,
    cantidad: elegidos.length,
    debito: Math.round(debito * 100) / 100,
    credito: Math.round(credito * 100) / 100,
    sinComprobante: elegidos.filter((a) => a.semaforo === 'sin_comprobante').length,
    conFechaDelPase: elegidos.filter((a) => mesFiscalCerrado(a.fecha, ano, mes)).length,
    porDocumento: Object.values(porDocumento).sort((a, b) => a.documento.localeCompare(b.documento)),
  };
}

export const fmtMoney = (v) =>
  (Number(v) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
